import { render } from "./uiFormInput.vue?vue&type=template&id=1ae4a2a7&scoped=true"
import script from "./uiFormInput.vue?vue&type=script&lang=js"
export * from "./uiFormInput.vue?vue&type=script&lang=js"

import "./uiFormInput.vue?vue&type=style&index=0&id=1ae4a2a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae4a2a7"]])

export default __exports__